export const CLIENT_ID = process.env.REACT_APP_PAY_PAL_CLIENT_ID!;
